<div class="admin-container">
  <div class="columns" *ngIf="sectionData.pictureColumns">
    <div *ngFor="let column of sectionData.pictureColumns" class="column">
      <div *ngFor="let picture of column.pictures" class="picture">
        <img [src]="picture.uploadSrc">
        <div class="legend" *ngIf="picture.legend">{{picture.legend}}</div>
        <i class="pi pi-arrow-circle-up" (click)="updatePictureColumnOrder(column, picture, -1)"></i>
        <i class="pi pi-arrow-circle-down" (click)="updatePictureColumnOrder(column, picture, 1)"></i>
        <i class="pi pi-trash" (click)="deletePicture(column, picture)"></i>
      </div>
      <div class="add-picture" (click)="addPicture(column)">
        <i class="pi pi-plus-circle"></i>
      </div>
    </div>
    <div class="add-column" (click)="addColumn()" [class.add-column-margin]="addColumnHasMargin()">
      <i class="pi pi-plus-circle"></i>
    </div>
  </div>
</div>

<p-dialog [(visible)]="edit">
  <div class="admin-modal" *ngIf="pictureModel">
    <form class="form">
      <div class="input-group">
        <label>Légende</label>
        <input type="text" [(ngModel)]="pictureModel.legend" name="legend">
      </div>
      <div class="input-group">
        <label>Description (alt)</label>
        <input type="text" [(ngModel)]="pictureModel.description" name="description">
      </div>
      <div class="input-group">
        <label>Image</label>
        <input #pictureInput type="file" (change)="onFileChanged($event)">
      </div>
      <div class="submit">
        <button (click)="edit = false">Annuler</button>
        <button (click)="addPictureToColumn()">Sauver</button>
      </div>
    </form>
  </div>
</p-dialog>